import styled from "styled-components"
import { media } from "../../helpers/responsive"
import DatePicker from "./datePicker"

type DateTimePickerSectionProps = {
  startDate: Date;
  endDate: Date;
  setStartDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
  startHour: number;
  setStartHour: (hour: number) => void;
  startMinute: number;
  setStartMinute: (minute: number) => void;
  endHour: number;
  setEndHour: (hour: number) => void;
  endMinute: number;
  setEndMinute: (minute: number) => void;
  planMinDate?: Date;
  onPlanLimitInteract?: () => void;
  layout?: "grid" | "stacked";
  compact?: boolean;
};

const DateTimePickerSection = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  startHour,
  setStartHour,
  startMinute,
  setStartMinute,
  endHour,
  setEndHour,
  endMinute,
  setEndMinute,
  planMinDate,
  onPlanLimitInteract,
  layout = "grid",
  compact = false,
}: DateTimePickerSectionProps) => {
  return (
    <Wrapper $layout={layout} $compact={compact}>
      <DatePicker
        key="start"
        pickType="start"
        currDate={startDate}
        setDate={setStartDate}
        hour={startHour}
        setHour={setStartHour}
        minute={startMinute}
        setMinute={setStartMinute}
        disableDateTimeDetails = {{
          hour: endHour,
          minute: endMinute,
          date: endDate,
        }}
        planMinDate={planMinDate}
        onPlanLimitInteract={onPlanLimitInteract}
        compact={compact}
      />
      <DatePicker
        key="end"
        pickType="end"
        currDate={endDate}
        setDate={setEndDate}
        hour={endHour}
        setHour={setEndHour}
        minute={endMinute}
        setMinute={setEndMinute}
        disableDateTimeDetails = {{
          hour: startHour,
          minute: startMinute,
          date: startDate,
        }}
        compact={compact}
      />
    </Wrapper>
  );
}

export default DateTimePickerSection

const Wrapper = styled.div<{ $layout: "grid" | "stacked"; $compact?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $layout }) => ($layout === "stacked" ? "1fr" : "1fr 1fr")};
  gap: ${({ $compact }) => ($compact ? "12px" : "16px")};
  padding: ${({ $compact }) => ($compact ? "0" : "16px")};

  ${media.down.xs} {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: ${({ $compact }) => ($compact ? "0" : "12px")};
  }
`;
